"use client"

/**
 * Client Providers (Client Component)
 *
 * This component wraps the app with all necessary providers:
 * - SessionProvider (NextAuth)
 * - SWRConfig
 * - ThemeProviders (Material-UI, styled-components, jss-rtl)
 * - GlobalContextProvider
 * - Layout (Header, Footer, FloatingChat)
 *
 * IMPORTANT: This is a Client Component because providers use React Context
 * which requires client-side JavaScript.
 */

import { SessionProvider } from "next-auth/react"
import { usePathname } from "next/navigation"
import { ReactNode } from "react"
import { SWRConfig } from "swr"
import Layout from "../../layout/Layout"
import { swrConfig } from "../../lib/admin/swr-config"
import ThemeProviders from "../../theme/ThemeProviders"

interface ClientProvidersProps {
  children: ReactNode
}

export default function ClientProviders({ children }: ClientProvidersProps) {
  const pathname = usePathname()
  const isAdminRoute = pathname?.startsWith("/admin")

  return (
    <SessionProvider>
      <SWRConfig value={swrConfig}>
        <ThemeProviders>
          {isAdminRoute ? children : <Layout>{children}</Layout>}
        </ThemeProviders>
      </SWRConfig>
    </SessionProvider>
  )
}
